<script lang="ts" setup>
import { VToaster } from "@app/core";

import MasterLayout from "@/app/layouts/MasterLayout.vue";
</script>

<template>
  <MasterLayout />
  <VToaster />
</template>
